module.exports = __webpack_public_path__ + "static/media/logoEmpresa.68989183.png";